import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { fetchOfficeStaffById } from "./supportContactService";
import { formatPhoneDisplay } from "../utils/phone";
import "../assets/css/ViewCustomer.css";
import "../assets/css/EditTenant.css";
import "../assets/css/Projects.css";
import "../assets/css/Tasks.css";

function ViewOfficeStaff({ staffId, onBack, onEdit }) {
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStaff = async () => {
      setLoading(true);
      try {
        const s = await fetchOfficeStaffById(staffId);
        if (s) {
          setStaff({
            id: s.Staff_Id ?? s.staff_id ?? s.Id ?? s.id,
            staffName: s.Staff_Name ?? s.staff_name ?? s.name ?? "",
            staffRole: s.Staff_Role ?? s.staff_role ?? "",
            phoneNumber: s.Phone_Number ?? s.phone_number ?? "",
            alternatePhone: s.Alternate_Phone ?? s.alternate_phone ?? "",
            email: s.Email ?? s.email ?? "",
            shiftStart: s.Shift_Start ?? s.shift_start ?? "",
            shiftEnd: s.Shift_End ?? s.shift_end ?? "",
            workingDays: s.Working_Days ?? s.working_days ?? "",
            supervisorName: s.Supervisor_Name ?? s.supervisor_name ?? "",
            status: s.Status ?? s.status ?? "Active",
            remarks: s.Remarks ?? s.remarks ?? ""
          });
        } else {
          setStaff(null);
        }
      } catch (err) {
        console.error("Error fetching office staff:", err);
        setStaff(null);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [staffId]);

  const InfoItem = ({ label, value }) => {
    const hasValue = value != null && value !== "" && value !== "—";
    return (
      <div className="viewlead-info-item">
        <span className={`viewlead-info-label ${hasValue ? "has-value" : ""}`}>{label}: </span>
        <span className={`viewlead-info-value ${!hasValue ? "muted" : ""}`}>{hasValue ? value : "—"}</span>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="viewlead-container">
        <div className="viewlead-loading">Loading staff details...</div>
      </div>
    );
  }

  if (!staff) {
    return (
      <div className="viewlead-container">
        <button type="button" className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back
        </button>
        <div
          className="error-message"
          style={{ backgroundColor: "#fee", color: "#c33", padding: "12px", borderRadius: "4px", marginTop: "16px" }}
        >
          Staff not found.
        </div>
      </div>
    );
  }

  const shift = [staff.shiftStart, staff.shiftEnd].filter(Boolean).join(" - ") || "—";

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button type="button" className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back
        </button>
        <button type="button" className="btn-subproject-primary" onClick={() => onEdit && onEdit(staff.id)}>
          Edit
        </button>
      </div>

      <div className="viewlead-card" style={{ marginBottom: 20 }}>
        <h3 className="viewlead-section-title">Staff Information</h3>
        <div className="viewlead-info-grid">
          <InfoItem label="Staff ID" value={String(staff.id)} />
          <InfoItem label="Staff Name" value={staff.staffName} />
          <InfoItem label="Staff Role" value={staff.staffRole} />
          <InfoItem label="Status" value={staff.status} />
          <InfoItem label="Phone" value={formatPhoneDisplay("", staff.phoneNumber)} />
          <InfoItem label="Alternate Phone" value={formatPhoneDisplay("", staff.alternatePhone)} />
          <InfoItem label="Email" value={staff.email} />
          <InfoItem label="Shift" value={shift} />
          <InfoItem label="Working Days" value={staff.workingDays} />
          <InfoItem label="Supervisor" value={staff.supervisorName} />
        </div>

        <h3 className="viewlead-section-title">Remarks</h3>
        <div className="viewlead-info-grid">
          <InfoItem label="Remarks" value={staff.remarks} />
        </div>
      </div>
    </div>
  );
}

export default ViewOfficeStaff;

